import { useState, useEffect } from 'react';
import { supabase } from '../lib/db.ts';

const DEFAULT = 10;

/** Live platform minimum trade floor (ZAR) from `get_min_trade_zar` RPC. */
export function useMinTradeZar(): number {
  const [floor, setFloor] = useState(DEFAULT);
  useEffect(() => {
    let cancelled = false;
    void (async () => {
      const { data, error } = await supabase.rpc('get_min_trade_zar');
      if (cancelled) return;
      const n = data != null ? Number(data) : NaN;
      if (!error && Number.isFinite(n)) {
        setFloor(Math.min(1000, Math.max(1, n)));
      }
    })();
    return () => {
      cancelled = true;
    };
  }, []);
  return floor;
}
